<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { exportVouchersUrl } from "./api";

const router = useRouter();
const today = new Date().toISOString().slice(0, 10);
const oneMonthAgo = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().slice(0, 10);

const redeemStatus = ref("all"), brand = ref("all"), duration = ref("last_month"), startDate = ref(oneMonthAgo), endDate = ref(today), voucherDuration = ref("all_time"), voucherStartDate = ref(oneMonthAgo), voucherEndDate = ref(today);

const redeemItems = [{ title: "All", value: "all" }, { title: "Redeemed", value: "true" }, { title: "Not Redeemed", value: "false" }];
const durationItems = [{ title: "All Time", value: "all_time" }, { title: "Last Month", value: "last_month" }, { title: "Last Year", value: "last_year" }, { title: "Custom", value: "custom" }];

const link = computed(() => exportVouchersUrl({ redeem_status: redeemStatus.value, brand: brand.value, duration: duration.value, start_date: startDate.value, end_date: endDate.value, voucher_duration: voucherDuration.value, voucher_start_date: voucherStartDate.value, voucher_end_date: voucherEndDate.value }));
</script>

<template>
  <section>
    <VBtn variant="text" prepend-icon="mdi:arrow-left" class="mb-4" @click="router.push({ name: 'bd-vouchers' })">Back</VBtn>
    <h1 class="text-h5 mb-4">Export BD Vouchers</h1>
    <VCard class="pa-4" max-width="640">
      <VRow>
        <VCol cols="12" md="6">
          <VSelect v-model="redeemStatus" label="Redeem Status" :items="redeemItems" item-title="title" item-value="value" />
        </VCol>
        <VCol cols="12" md="6">
          <VSelect v-model="duration" label="Redemption Date Range" :items="durationItems" item-title="title" item-value="value" />
        </VCol>
        <template v-if="duration === 'custom'">
          <VCol cols="12" md="6"><VTextField v-model="startDate" label="Start Date" type="date" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="endDate" label="End Date" type="date" /></VCol>
        </template>
        <VCol cols="12" md="6">
          <VSelect v-model="voucherDuration" label="Voucher Date Range" :items="durationItems" item-title="title" item-value="value" />
        </VCol>
        <template v-if="voucherDuration === 'custom'">
          <VCol cols="12" md="6"><VTextField v-model="voucherStartDate" label="Voucher Start" type="date" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="voucherEndDate" label="Voucher End" type="date" /></VCol>
        </template>
        <VCol cols="12">
          <VBtn :href="link" target="_blank" prepend-icon="mdi:download">Export CSV</VBtn>
        </VCol>
      </VRow>
    </VCard>
  </section>
</template>
